import React, { useState, useRef, useEffect } from "react";
import Navigation from "../../Component/Navigation";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Fond from "../../Component/Fond";

const Profil_coach = () => {
  const [active, setActive] = useState(false);

  const classToggle = () => {
    setActive(!active);
  };

  // const profilcoach = document.querySelector(".bloc4_profil_coach");

  // window.addEventListener('scroll', () =>{
  //   console.log(window.scrollY);
  //   if(window.scrollY > 500){
  //     profilcoach.classList.add("open");
  //   }
  //   else{
  //     profilcoach.classList.remove("open");
  //   }
  // })

  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const callbackFunction = (entries) => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  };

  const options = {
    root: null,
    rootMargin: "10px 0px",
    threshold: 1.0,
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef, options]);

  return (
    <section>
      <div className={` ${active ? "blur" : ""}`}>
        {/* <Fond /> */}
        <Navigation />
        <div className="global_profil_coach">
          <img
            src="./Media/PT-site.jpg"
            alt="fond-coach"
            className="fond_site_coach"
          />
          <div className="bloc0_profil_coach">
            <div className="bloc1_profil_coach">
              <div className="imgcontent">
                <img src="./Media/thibaut.jpg" alt="moi" />
                <div className="myname">
                  <h3 data-text="Senechal Thibaut">Senechal Thibaut</h3>
                </div>
              </div>
              <div className="idcontent">
                <ul>
                  <CopyToClipboard text="senechal.thibaut@hotmail.fr">
                    <li className="copyvalid" onClick={classToggle}>
                      senechal.thibaut@hotmail.fr
                    </li>
                  </CopyToClipboard>
                  <CopyToClipboard text="0770390083">
                    <li className="phone copyvalid" onClick={classToggle}>
                      07.70.39.00.83
                    </li>
                  </CopyToClipboard>
                  <CopyToClipboard text="bordeaux">
                    <li className="copyvalid" onClick={classToggle}>
                      Bordeaux
                    </li>
                  </CopyToClipboard>
                </ul>
                <div className="Vcard"></div>
              </div>

              <div className="idsocial">
                <a
                  href="https://www.linkedin.com/in/thibaut-senechal-aabbbb199/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.instagram.com/personnel_perf/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="bloc2_profil_coach">
            <div className="bloc3_profil_coach">
              <div className="diplome">
                <h3>Diplôme</h3>
                <p>
                  Licence STAPS - Entrainement Sportif - Bordeaux
                  <br />
                  <span>Spécialité:</span> Musculation, Force Athéltique,
                  Haltérophile.
                </p>
              </div>
              <div className="xpcoach">
                <h3>Experience Coach</h3>
                <ul>
                  <li>Coaching à Domicile</li>
                  <li>Studio d'electro-stimulation</li>
                  <li>Préparation Physique Baskette - JSA NM1</li>
                  <li>Personal Trainer - Basic Fit</li>
                  <li>Préparation Physique Tennis - Junior Compétition</li>
                </ul>
              </div>
              <div className="xpsport">
                <h3>Experience Sport</h3>
                <p>
                  Je fais du sport depuis mon plus jeune âge et pratiquée
                  variété de sport{" "}
                  <em>
                    (judo, foot, break, athlétisme, gym, parkour, boxe/mma,
                    rugby...)
                  </em>
                  . Mais le sport que j'ai pratiqué le plus longtemps et que je
                  pratique encore c'est bien la <span>musculation/fitness</span>
                  . Cela fait maintenant plus de <span>10 ans</span> que je la
                  pratique et parfois en parallèle d'une autre activité
                  sportive.
                  <br />
                  <br />
                  J'ai aussi eu l'occasion de pratiquer la compétition dans les
                  différentes activités que j'ai effectué, mais n'étant pas
                  pleinement passionné dans ces derniers, ce fut à chaque fois
                  bref.
                </p>
              </div>
            </div>

            <div
              className={`bloc4_profil_coach ${isVisible ? "open" : ""}`}
              ref={containerRef}
            >
              <h3>Petit Mot</h3>
              <p>
                Ma passion, vous l'aurez compris est le sport dans lequel j'ai
                choisi d'exercer. Plus exactement,{" "}
                <span>
                  j'ai choisi d'accompagner l'humain dans sa quête de
                  performance
                </span>
                . Et j'entends par performance tout challenge qu'il est possible
                de se fixer, que l'on soit athlète de très haut niveau ou
                sédentaire. Sortir de son inactivité et passer d'un état
                d'obésité à un corps en parfaite santé est tout au temps une
                performance que la recherche d'un meilleur chrono au 100m. La
                performance se détermine par les qualités de l'individu. Si
                hier, vous n’étiez pas capable de faire 10 pompes et que demain
                vous en faite 12, vous avez réalisé une performance.
                <br /> <br />​ C'est pourquoi j'ai choisi de proposer mes
                services pour{" "}
                <span>tout challenge de développement physique</span>. Que ce
                soit un <span>développement personnel</span>, pour un{" "}
                <span>concours</span> (pompier, armée, etc...) ou pour de la{" "}
                <span>compétition</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={`popuphome ${active ? "active" : ""}`}>
        <h2>Copié !</h2>
        <span className="copyvalid" onClick={classToggle}>
          ok
        </span>
      </div>
    </section>
  );
};

export default Profil_coach;
